import React, { Component } from "react";
import EmpresaContext from "../../context";
import { Empresa } from "smart-imob-types";
import { Link } from "react-router-dom";
import InputMask from "react-input-mask";

class Registration extends Component {
  state = {
    nome: "",
    email: "",
    telefone: "",
    msg: "",
    enviado: false
  };
  componentDidMount() {
    this.setState({
      enviado: sessionStorage.getItem("enviado_imovel") === "enviado"
    });
  }
  createURL = ({ contato_email, to_email, mensagem, telefone, nome }) =>
    `https://us-central1-smartimob-dev-test.cloudfunctions.net/EnvieSeuImovel?contato_email=${contato_email}&nome=${nome}&mensagem=${mensagem}&to_email=${to_email}&telefone=${telefone}&a=1`;
  sendEmail = () => {
    const { nome, email, msg, telefone } = this.state;
    if (!nome || !email || !msg || !telefone)
      return alert("Alguma informação para o envio está faltando!");
    sessionStorage.setItem("enviado_imovel", "enviado");
    this.setState({ enviado: true });
    let req_url = this.createURL({
      contato_email: email,
      nome,
      mensagem: msg,
      telefone,
      to_email: this.context["email_envio_de_imovel"] || this.context.email
    });
    window.open(req_url);
  };
  render() {
    return (
      <div className="register-page-area pd-bottom-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-4 col-lg-5 col-md-6 mb-5 mb-md-0">
              <div className="contact-form-wrap contact-form-bg">
                {!this.state.enviado ? (
                  <>
                    <h4>Envie seu imóvel por email</h4>
                    <div className="rld-single-input">
                      <input
                        value={this.state.nome}
                        onChange={e => this.setState({ nome: e.target.value })}
                        type="text"
                        placeholder="Nome"
                      />
                    </div>
                    <div className="rld-single-input">
                      <input
                        value={this.state.email}
                        onChange={e => this.setState({ email: e.target.value })}
                        type="text"
                        placeholder="Email"
                      />
                    </div>
                    <div className="rld-single-input">
                      <InputMask
                        id="Telefone"
                        mask="(99) 99999-9999"
                        onChange={e =>
                          this.setState({ telefone: e.target.value })
                        }
                        placeholder="Telefone"
                        value={this.state.telefone}
                      />
                    </div>
                    <div className="rld-single-input">
                      <textarea
                        value={this.state.msg}
                        onChange={e => this.setState({ msg: e.target.value })}
                        rows={10}
                        placeholder="Mensagem"
                        defaultValue={""}
                        style={{ transitionDuration: "0s" }}
                      />
                    </div>
                    <div className="btn-wrap">
                      <button
                        className="btn btn-yellow"
                        disabled={this.context.envie_seu_imovel === false}
                        onClick={this.sendEmail}
                      >
                        Enviar contato
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <h4>Cadastro enviado!</h4>
                    <div className="btn-wrap">
                      <Link to="/" className="btn btn-yellow">
                        Voltar para home
                      </Link>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  context!: Empresa;
}
Registration.contextType = EmpresaContext;
export default Registration;
